import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Validates IBANs using the official IBAN modulus 97 (https://www.iban.nl/iban/iban-controle-mod-97-berekening/)
export function isValidIban(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let value = control.value;
    if (typeof value !== 'string') return null;
    value = value.replace(/\s+/g, '').toUpperCase();

    // IBAN: NLkk BBBB CCCC CCCC CC
    if (!/^NL\d{2}[A-Z]{4}\d{10}$/.test(value)) {
      return { ibanError: true };
    }

    // 1. Move first 4 chars to the end
    const rearranged = value.slice(4) + value.slice(0, 4);

    // 2. Replace each letter with its number (A=10, ..., Z=35)
    let numeric = '';
    for (let i = 0; i < rearranged.length; i++) {
      const char = rearranged[i];
      if (char >= 'A' && char <= 'Z') {
        numeric += (char.charCodeAt(0) - 55).toString();
      } else {
        numeric += char;
      }
    }

    // 3. Calculate mod-97
    let remainder = numeric;
    while (remainder.length > 2) {
      const block = remainder.substring(0, 9);
      remainder =
        (parseInt(block, 10) % 97).toString() +
        remainder.substring(block.length);
    }
    if (parseInt(remainder, 10) % 97 !== 1) {
      return { ibanError: true };
    }

    return null;
  };
}
